<script>
  import { VStack } from "./layout";
  import { fromSQLDate } from "../date.js";

  export let date;
  export let name;

  let now = new Date();
  console.log(now);
  let d = fromSQLDate(date);
  console.log(d);
  let remaining = Math.ceil((d.getTime() - now.getTime()) / (1000 * 3600 * 24)); // in days
  let months = Math.round(remaining / 30);
  let days = Math.ceil(remaining % 30);
</script>

<h1>{name}</h1>
<article>
  <VStack>
    <div class="counter">
      J - {remaining}
      {#if months > 0}(~ {months} mois){/if}
    </div>
    <div class="date">Date du mariage: {d.toLocaleDateString()}</div>
  </VStack>
</article>

<style>
  article {
    padding-left: 1em;
    color: white;
    background-color: var(--primary-color);
    width: fit-content;
  }
  .counter {
    color: var(--secondary-light-color);
    font-size: x-large;
  }
  h1 {
    color: white;
    white-space: nowrap;
  }
</style>
